var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightUpNewSmall = function SvgArrowRightUpNewSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.97 9.47-.53.531 1.06 1.06.53-.53zm7.677-5.556a.75.75 0 1 0-1.06-1.06zM2.5 10.001l.53.53 6.617-6.617-.53-.53-.53-.53L1.97 9.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M2.316 2.817h7.367v7.367"
  })));
};
export default SvgArrowRightUpNewSmall;